import { apiRequest } from "../lib/apiClient";
import type {
  GeneratedDocumentCreate,
  GeneratedDocumentOut,
  GeneratedDocumentStatus,
  GeneratedDocumentUpdate,
} from "./types";

export function listGeneratedDocuments(
  accessToken: string,
  status?: GeneratedDocumentStatus,
): Promise<GeneratedDocumentOut[]> {
  return apiRequest<GeneratedDocumentOut[]>("/documents", { accessToken, query: { status } });
}

export function createGeneratedDocument(accessToken: string, body: GeneratedDocumentCreate): Promise<GeneratedDocumentOut> {
  return apiRequest<GeneratedDocumentOut>("/documents", { method: "POST", accessToken, body });
}

export function getGeneratedDocument(accessToken: string, documentId: string): Promise<GeneratedDocumentOut> {
  return apiRequest<GeneratedDocumentOut>(`/documents/${documentId}`, { accessToken });
}

export function updateGeneratedDocument(
  accessToken: string,
  documentId: string,
  body: GeneratedDocumentUpdate,
): Promise<GeneratedDocumentOut> {
  return apiRequest<GeneratedDocumentOut>(`/documents/${documentId}`, { method: "PATCH", accessToken, body });
}

export function deleteGeneratedDocument(accessToken: string, documentId: string): Promise<void> {
  return apiRequest<void>(`/documents/${documentId}`, { method: "DELETE", accessToken });
}
